import "what-input";
import Vue from "vue";
import { instance } from "./api/instance.js";
import Fancybox from '@fancyapps/fancybox';
import videojs from 'video.js';
import TextAnimation from "./components/TextAnimation";

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below

// Use API
Vue.prototype.$http = instance;

// Enable to use Vue.js
var vue = new Vue({
  el: "#app",
    components: {
        TextAnimation
    },
  data: {
  	menu_active: false,
      subscribe_active: false,
    name: "Test"
  },
  mounted() {
      document.querySelectorAll(".image-slider").forEach((container) => {
          var swiper = new Swiper(container, {
              slidesPerView: "auto",
              centeredSlides:false,
              mousewheel: {
                  forceToAxis: true,
              },
              spaceBetween: 15,
              breakpoints: {
                  640: {
                      spaceBetween: 30,
                  },
              }
          });
      });

      document.querySelectorAll(".profile-swiper-inner").forEach((container) => {
          var swiper = new Swiper(container, {
              slidesPerView: 1,
              centeredSlides: false,
              loop: true,
              lazyPreloadPrevNext: 6,
              mousewheel: {
                  forceToAxis: true,
              },
              spaceBetween: 30,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              breakpoints: {
                  768: {
                      slidesPerView: 2,
                  },
                  1400: {
                      slidesPerView: 3,
                      spaceBetween: 50
                  },
              }
          });
      });
    console.log("Running Vue.js");
  },
  methods: {
  	toggle_menu: function() {
  		this.menu_active = !this.menu_active;
  	}
  }
});


(function($) {
    $(document).ready(function() { // Loaded when DOM is ready
        console.log("Running jQuery");

        $('.subscribe-btn').on('click', () => {
            toggleSubscribe();
        });

        $('.subscribe-popup .overlay').on('click', () => {
            toggleSubscribe();
        });

        function toggleSubscribe() {
            if(vue.menu_active) {
                toggleMenu();
            }

            vue.subscribe_active = !vue.subscribe_active;
            $('.subscribe-popup').toggleClass('active');

            if(vue.subscribe_active) {
                $('body').css('overflow', 'hidden');
            } else {
                $('body').css('overflow', 'visible');
            }
        }

        $('#burger').on('click', () => {
          toggleMenu();
        });

        $('.burger-overlay').on('click', () => {
          toggleMenu();
        })

        $('.burger-menu .close').on('click', () => {
          toggleMenu();
        })

        function toggleMenu() {
          vue.menu_active = !vue.menu_active;
          $('#burger').toggleClass('is-active');
          $('.burger-menu').toggleClass('is-active');
          $('.burger-overlay').toggleClass('is-active');

          if(vue.menu_active) {
            $('body').css('overflow', 'hidden');
          } else {
            $('body').css('overflow', 'visible');
          }
        }

        $('.share-button').on('click', () => {
          $('.share-buttons').addClass('show');
          $('.share-button').addClass('hide');
        });

        $('.copy-link-icon').on('click', (e) => {
          $('.link-copied').addClass('show');
          setTimeout(() => {
            $('.link-copied').removeClass('show');
          }, 2000);

          var $temp = $("<input>");
          $("body").append($temp);
          $temp.val(e.target.dataset.link).select();
          document.execCommand("copy");
          $temp.remove();
        });

        window.addEventListener('scroll', onWindowScroll);

        function isScrolledIntoView(elem) {
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();

          var elemTop = $(elem).offset().top;
          var elemBottom = elemTop + 200;

          return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) || elemTop < docViewTop;
        }

        $('.animate-in').each(function () {
          if (isScrolledIntoView(this) === true) {
              $(this).addClass('in-view')
          }
        });

        function onWindowScroll() {
          $('.animate-in').each(function () {
              if (isScrolledIntoView(this) === true) {
                  $(this).addClass('in-view')
              }
          });


          if($('.progress-container').length) {
            updateScrollBar();
          }

          if(window.scrollY > 100) {
            $('header').addClass('scrolled');
            $('.burger-menu').addClass('scrolled');
          } else {
            $('header').removeClass('scrolled');
            $('.burger-menu').removeClass('scrolled');
          }
        }

        $(".mute-unmute-btn").each(function () {
            let muted = true;
            $(this).on('click', function () {
                muted = !muted;
                const index = $(this).data()["index"];
                const video = window.innerWidth < 768 && $("#video-banner-" + index + ".video-banner-mobile").length !== 0 ? $("#video-banner-" + index + ".video-banner-mobile") : $("#video-banner-" + index + ".video-banner-desktop");
                if(muted) {
                    $(this).find(".mute").removeClass("hidden");
                    $(this).find(".unmute").addClass("hidden");

                    video.prop("muted", true);
                } else {
                    $(this).find(".mute").addClass("hidden");
                    $(this).find(".unmute").removeClass("hidden");

                    video.prop("muted", false);
                }
            });
        });


        function updateScrollBar() {
          var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
          var height = $('.byline').offset().top - document.documentElement.clientHeight;
          var scrolled = (winScroll / height) * 100;
          document.getElementById("myBar").style.width = scrolled + "%";
        }

        $('[data-fancybox]').fancybox({
          video: {
            tpl:
              '<video preload="none" paused class="fancybox-video video-js" controls controlsList="nodownload" poster="{{poster}}">' +
              '<source src="{{src}}" type="{{format}}" />' +
              'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
              "</video>",
            format: "",
            autoStart: true
          }
        });

        $( ".inline-video" ).each(function() {
            const i = $(this).data()["index"];
            let player;
            var Component = videojs.getComponent('Component'); // base component
            var videoTitle = videojs.extend(Component, {
                constructor: function(player, options) {
                    Component.apply(this, arguments);
                    // If a `text` option was passed in, update the text content of
                    // the component.
                    if (options.text) {
                        this.updateTextContent(options.text);
                    }
                },
                // The `createEl` function of a component creates its DOM element.
                createEl: function() {
                    return videojs.dom.createEl('div', {
                        // Prefixing classes of elements within a player with "vjs-"
                        // is a convention used in Video.js.
                        className: 'vjs-video-title ',
                    });
                },
                // This function could be called at any time to update the text
                // contents of the component.
                updateTextContent: function(text) {
                    // If no text was provided, default to "Title Unknown"
                    if (typeof text !== 'string') {
                        text = 'Unknown title';
                    }
                    // Use Video.js utility DOM methods to manipulate the content
                    // of the component's element.

                    videojs.dom.emptyEl(this.el());
                    videojs.dom.appendContent(this.el(), text);
                }
            });
            // Register the component with Video.js, so it can be used in players.
            videojs.registerComponent('videoTitle', videoTitle);
            const selector = ".inline-video[data-index='"+i+"']";

            player = videojs(document.querySelector(selector), {
                bigPlayButton: false,
                controlBar: {
                    volumePanel: false,
                    playToggle: true,
                    fullscreenToggle: true,
                    remainingTimeDisplay: true,
                    audioTrackButton: false,
                    progressControl: {
                        seekBar: {
                            loadProgressBar: true,
                            mouseTimeDisplay: true,
                            playProgressBar: true,
                        },
                    },
                    pictureInPictureToggle: false,
                },
            });
            player.playsinline('true');

            player.on('touchstart', function (e) {
                if (e.target.nodeName === 'VIDEO') {
                    if (player.paused()) {
                        this.play();
                    } else {
                        this.pause();
                    }
                }
            });
        });


        let player;
        var Component = videojs.getComponent('Component'); // base component
        var videoTitle = videojs.extend(Component, {
          constructor: function(player, options) {
            Component.apply(this, arguments);
            // If a `text` option was passed in, update the text content of
            // the component.
            if (options.text) {
              this.updateTextContent(options.text);
            }
          },
          // The `createEl` function of a component creates its DOM element.
          createEl: function() {
            return videojs.dom.createEl('div', {
              // Prefixing classes of elements within a player with "vjs-"
              // is a convention used in Video.js.
              className: 'vjs-video-title ',
            });
          },
          // This function could be called at any time to update the text
          // contents of the component.
          updateTextContent: function(text) {
            // If no text was provided, default to "Title Unknown"
            if (typeof text !== 'string') {
              text = 'Unknown title';
            }
            // Use Video.js utility DOM methods to manipulate the content
            // of the component's element.

            videojs.dom.emptyEl(this.el());
            videojs.dom.appendContent(this.el(), text);
          }
        });
        // Register the component with Video.js, so it can be used in players.
        videojs.registerComponent('videoTitle', videoTitle);

        $(document).on('afterLoad.fb', function(e, instance, slide) {
          player = videojs(document.querySelector('.fancybox-video'), {
            bigPlayButton: false,
            controlBar: {
              volumePanel: false,
              playToggle: true,
              fullscreenToggle: true,
              remainingTimeDisplay: true,
              audioTrackButton: false,
              progressControl: {
                seekBar: {
                  loadProgressBar: true,
                  mouseTimeDisplay: true,
                  playProgressBar: true,
                },
              },
              pictureInPictureToggle: false,
            },
          });
          player.playsinline('true');

          player.on('touchstart', function (e) {
            if (e.target.nodeName === 'VIDEO') {
              if (player.paused()) {
                this.play();
              } else {
                this.pause();
              }
            }
          });
        });

        // $(document).on('afterClose.fb', function(e, instance, slide) {
        //   console.log("HEJidsj");
        // });

        $(document).on('afterShow.fb', function(e, instance, slide) {
          let videoHolder, videoPlayer, videoPlayerContainer, videoOverlay, videoPresent = true;

          let setVariables = function() {
            try {
              videoHolder = document.querySelector('.fancybox-content');
              videoPlayer = videoHolder.querySelector('video');
              videoPlayerContainer = videoPlayer.parentElement;
              videoOverlay = videoHolder.querySelector('.video-js.vjs-big-play-centered');
            } catch(err){
              console.log('no video on this page');
              videoPresent = false;
            }
          };

          setVariables();

          let isPlaying = function() { return (videoPlayerContainer.classList.contains('vjs-playing')); };

          let togglePlay = function () {
            console.log("TOGGLE PLAY");
            if (isPlaying()) { videoPlayer.pause(); }
            else { videoPlayer.play(); }
          };

          function handleKeypress(event) {
            if ((event.isComposing || event.keyCode === 32) && videoPresent) {
              // //stop window from scrolling down
              event.preventDefault();
              // check if video has changed
              // if (getId(videoHolder) != getId(document.querySelector('.fancybox-content'))) setVariables();

              //if the video hasn't been started at all, trigger that
              if (videoOverlay && videoOverlay.style.display != "none") videoOverlay.click();
              // otherwise, use player controls
              else if (videoHolder) togglePlay();
            }
          }

          document.addEventListener("keydown", handleKeypress);

          if((slide.type === 'video')) {
            let trigger = instance.$trigger[0];
            player.addChild('videoTitle', {
              text: '',
            });
            let titleObj = $('.vjs-video-title');
            titleObj.append("<div><span style='display:inline-block;'>" + trigger.getAttribute('data-video-title') + "</span><span style='display: inline-block; margin-left: 8px;'></span></div>");
          }
        });


    });
})( jQuery );
